import ApiCollection                  from 'Collections/ApiCollection';
import PagedCollection                from 'Collections/PagedCollection';
import PartitionAddressModel          from 'Models/partition/PartitionAddressModel';
import PartitionLegalInformationModel from 'Models/partition/PartitionLegalInformationModel';
import PartitionModel                 from 'Models/partition/PartitionModel';
import OwnerPartitionModel            from 'Models/sales/OwnerPartitionModel';
import PartitionConfigModel           from 'Models/sales/PartitionConfigModel';
import AbstractModelXStore            from 'stores/AbstractModelXStore';

export default class PartitionDashboardStore extends AbstractModelXStore {
	public ownerPartition: OwnerPartitionModel | null = null;
	public partition = new PartitionModel();
	public partitionAddressCollection = new ApiCollection(PartitionAddressModel);
	public partitionLegalInformationCollection = new ApiCollection(PartitionLegalInformationModel);
	public salesPartitionConfigCollection = new ApiCollection(PartitionConfigModel);
	
	private _ownerPartitionCollection = new PagedCollection(OwnerPartitionModel);

	public async initAsync(id: id) {
		await this.partition.setId(id).fetch();
		await this._ownerPartitionCollection.listBy([this.partition.urn], 'partitionUrn');
		this.ownerPartition = this._ownerPartitionCollection.first();

		return Promise.all([
			this.partitionAddressCollection.listBy([id], 'partition'),
			this.partitionLegalInformationCollection.listBy([id], 'partition'),
			this.salesPartitionConfigCollection
				.setRequiredFilter('reference', 'MINIMAL_OFFER_GROSS_MARGIN_RATE')
				.listBy([this.partition.urn], 'partitionUrn'),
		]);
	}
}
